import apiService from "@/core/services/apiService";

export type State = { classes: object };
import {Module, VuexModule, Mutation, Action} from "vuex-module-decorators";
import {Actions, Mutations} from "@/store/enums/store.enums";
import {ShopActions, ShopMutation} from "@/modules/shop/store/enums";

@Module
export default class Store extends VuexModule {
    categories = [];
    deliveryOptions = [];
    orderStates = [];
    storages = [];
    countries = [];
    attributes = [];
    facettes = [];
    ingredients = [];
    healthclaims = [];

    get getShopCategories() {
        return this.categories;
    }

    get getShopDeliveryOptions() {
        return this.deliveryOptions;
    }

    get getShopOrderStates() {
        return this.orderStates;
    }

    get getShopStorages() {
        return this.storages;
    }

    get getShopCountries() {
        return this.countries;
    }

    get getShopAttributes() {
        return this.attributes;
    }

    get getShopFacettes() {
        return this.facettes;
    }

    get getShopIngredients() {
        return this.ingredients;
    }

    get getShopHealthclaims() {
        return this.healthclaims;
    }

    @Mutation
    [ShopMutation.SET_CATEGORIES](data) {
        this.categories = data;
    }

    @Mutation
    [ShopMutation.SET_DELIVERY_OPTIONS](data) {
        this.deliveryOptions = data;
    }

    @Mutation
    [ShopMutation.SET_ORDER_STATES](data) {
        this.orderStates = data;
    }

    @Mutation
    [ShopMutation.SET_STORAGES](data) {
        this.storages = data;
    }

    @Mutation
    [ShopMutation.SET_COUNTRIES](data) {
        this.countries = data;
    }

    @Mutation
    [ShopMutation.SET_ATTRIBUTES](data) {
        this.attributes = data;
    }

    @Mutation
    [ShopMutation.SET_FACETTES](data) {
        this.facettes = data;
    }

    @Mutation
    [ShopMutation.SET_INGREDIENTS](data) {
        this.ingredients = data;
    }

    @Mutation
    [ShopMutation.SET_HEALTHCLAIMS](data) {
        this.healthclaims = data;
    }

    @Action
    [ShopActions.FETCH_CATEGORIES]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("shop-admin/categories").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ShopMutation.SET_CATEGORIES, data.result);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopActions.GET_CATEGORY](categoryId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`shop-admin/category/${categoryId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopActions.CREATE_CATEGORY](payload) {

        return new Promise((resolve, reject) => {

            apiService.post("shop-admin/create-category", payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                // refresh categories //
                this.context.dispatch(ShopActions.FETCH_CATEGORIES);

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopActions.UPDATE_CATEGORY](payload) {

        return new Promise((resolve, reject) => {

            const {categoryId, data: updateData} = payload;

            apiService.put(`shop-admin/update-category/${categoryId}`, updateData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                // refresh categories //
                this.context.dispatch(ShopActions.FETCH_CATEGORIES);

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopActions.DELETE_CATEGORY](categoryId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`shop-admin/delete-category/${categoryId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                // refresh categories //
                this.context.dispatch(ShopActions.FETCH_CATEGORIES);

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopActions.FETCH_DELIVERY_OPTIONS]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("shop-admin/delivery-options").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ShopMutation.SET_DELIVERY_OPTIONS, data.result);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopActions.CREATE_DELIVERY_OPTION](payload) {

        return new Promise((resolve, reject) => {

            apiService.post("shop-admin/create-delivery-option", payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_DELIVERY_OPTIONS);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.UPDATE_DELIVERY_OPTION](payload) {

        return new Promise((resolve, reject) => {

            const {deliveryId, data: updateData} = payload;

            apiService.put(`shop-admin/update-delivery-option/${deliveryId}`, updateData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_DELIVERY_OPTIONS);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.DELETE_DELIVERY_OPTION](deliveryId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`shop-admin/delete-delivery-option/${deliveryId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_DELIVERY_OPTIONS);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.FETCH_ORDER_STATES]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("shop-admin/order-states").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ShopMutation.SET_ORDER_STATES, data.result);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopActions.CREATE_ORDER_STATE](payload) {

        return new Promise((resolve, reject) => {

            apiService.post("shop-admin/create-order-state", payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_ORDER_STATES);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.UPDATE_ORDER_STATE](payload) {

        return new Promise((resolve, reject) => {

            const {orderStateId, data: updateData} = payload;

            apiService.put(`shop-admin/update-order-state/${orderStateId}`, updateData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_ORDER_STATES);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.DELETE_ORDER_STATE](orderStateId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`shop-admin/delete-order-state/${orderStateId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_ORDER_STATES);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.FETCH_STORAGES]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("shop-admin/storages").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ShopMutation.SET_STORAGES, data.result);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ShopActions.FETCH_COUNTRIES]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("shop-admin/countries").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ShopMutation.SET_COUNTRIES, data.result);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    // ═══════════════════════════════════════════════════════
    //  Storages CRUD
    // ═══════════════════════════════════════════════════════

    @Action
    [ShopActions.CREATE_STORAGE](payload) {

        return new Promise((resolve, reject) => {

            apiService.post("shop-admin/create-storage", payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_STORAGES);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.UPDATE_STORAGE](payload) {

        return new Promise((resolve, reject) => {

            const {storageId, data: updateData} = payload;

            apiService.put(`shop-admin/update-storage/${storageId}`, updateData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_STORAGES);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.DELETE_STORAGE](storageId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`shop-admin/delete-storage/${storageId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_STORAGES);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    // ═══════════════════════════════════════════════════════
    //  Countries CRUD
    // ═══════════════════════════════════════════════════════

    @Action
    [ShopActions.CREATE_COUNTRY](payload) {

        return new Promise((resolve, reject) => {

            apiService.post("shop-admin/create-country", payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_COUNTRIES);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.UPDATE_COUNTRY](payload) {

        return new Promise((resolve, reject) => {

            const {countryId, data: updateData} = payload;

            apiService.put(`shop-admin/update-country/${countryId}`, updateData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_COUNTRIES);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.DELETE_COUNTRY](countryId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`shop-admin/delete-country/${countryId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_COUNTRIES);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    // ═══════════════════════════════════════════════════════
    //  Attributes CRUD
    // ═══════════════════════════════════════════════════════

    @Action
    [ShopActions.FETCH_ATTRIBUTES]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("shop-admin/attributes").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ShopMutation.SET_ATTRIBUTES, data.result);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.CREATE_ATTRIBUTE](payload) {

        return new Promise((resolve, reject) => {

            apiService.post("shop-admin/create-attribute", payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_ATTRIBUTES);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.UPDATE_ATTRIBUTE](payload) {

        return new Promise((resolve, reject) => {

            const {attributeId, data: updateData} = payload;

            apiService.put(`shop-admin/update-attribute/${attributeId}`, updateData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_ATTRIBUTES);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.DELETE_ATTRIBUTE](attributeId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`shop-admin/delete-attribute/${attributeId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_ATTRIBUTES);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    // ═══════════════════════════════════════════════════════
    //  Facetten CRUD
    // ═══════════════════════════════════════════════════════

    @Action
    [ShopActions.FETCH_FACETTES]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("shop-admin/facette-categories").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ShopMutation.SET_FACETTES, data.result);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.CREATE_FACETTE_MAIN](payload) {

        return new Promise((resolve, reject) => {

            apiService.post("shop-admin/create-facette-main", payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_FACETTES);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.UPDATE_FACETTE_MAIN](payload) {

        return new Promise((resolve, reject) => {

            const {facetteId, data: updateData} = payload;

            apiService.put(`shop-admin/update-facette-main/${facetteId}`, updateData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_FACETTES);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.DELETE_FACETTE_MAIN](facetteId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`shop-admin/delete-facette-main/${facetteId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_FACETTES);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.CREATE_FACETTE_SUB](payload) {

        return new Promise((resolve, reject) => {

            apiService.post("shop-admin/create-facette-sub", payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_FACETTES);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.UPDATE_FACETTE_SUB](payload) {

        return new Promise((resolve, reject) => {

            const {facetteId, data: updateData} = payload;

            apiService.put(`shop-admin/update-facette-sub/${facetteId}`, updateData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_FACETTES);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.DELETE_FACETTE_SUB](facetteId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`shop-admin/delete-facette-sub/${facetteId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_FACETTES);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    // ═══════════════════════════════════════════════════════
    //  Ingredients CRUD
    // ═══════════════════════════════════════════════════════

    @Action
    [ShopActions.FETCH_INGREDIENTS]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("shop-admin/ingredients-list").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ShopMutation.SET_INGREDIENTS, data.result);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.CREATE_INGREDIENT](payload) {

        return new Promise((resolve, reject) => {

            apiService.post("shop-admin/create-ingredient", payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_INGREDIENTS);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.UPDATE_INGREDIENT](payload) {

        return new Promise((resolve, reject) => {

            const {ingredientId, data: updateData} = payload;

            apiService.put(`shop-admin/update-ingredient/${ingredientId}`, updateData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_INGREDIENTS);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.DELETE_INGREDIENT](ingredientId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`shop-admin/delete-ingredient/${ingredientId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_INGREDIENTS);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.UPDATE_INGREDIENT_HEALTHCLAIMS](payload) {

        return new Promise((resolve, reject) => {

            const {ingredientId, healthclaimIds} = payload;

            apiService.post(`shop-admin/update-ingredient-healthclaims/${ingredientId}`, { healthclaimIds } as any).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_INGREDIENTS);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    // ═══════════════════════════════════════════════════════
    //  Health Claims CRUD
    // ═══════════════════════════════════════════════════════

    @Action
    [ShopActions.FETCH_HEALTHCLAIMS]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("shop-admin/healthclaims-list").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ShopMutation.SET_HEALTHCLAIMS, data.result);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.CREATE_HEALTHCLAIM](payload) {

        return new Promise((resolve, reject) => {

            apiService.post("shop-admin/create-healthclaim", payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_HEALTHCLAIMS);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.UPDATE_HEALTHCLAIM](payload) {

        return new Promise((resolve, reject) => {

            const {healthclaimId, data: updateData} = payload;

            apiService.put(`shop-admin/update-healthclaim/${healthclaimId}`, updateData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_HEALTHCLAIMS);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ShopActions.DELETE_HEALTHCLAIM](healthclaimId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`shop-admin/delete-healthclaim/${healthclaimId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ShopActions.FETCH_HEALTHCLAIMS);
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

}
